import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectOption = state => state.get('select', initialState);

const makeSelectOption = () =>
  createSelector(selectOption, selectedState => selectedState.get('option'));

const makeSelectModalOption = () =>
  createSelector(selectOption, selectedState =>
    selectedState.get('modalOption'),
  );

export { selectOption, makeSelectOption, makeSelectModalOption };
